import keyMirror from 'keymirror'

export default keyMirror({
  NEW_LOG: null
})



// WEBPACK FOOTER //
// ./src/app/constants/ActionTypes.js